import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function CreatePlacement() {
  const navigate = useNavigate();

  const [placement, setPlacement] = useState({
    employee_id: "",
    full_name: "",
    designation: "",
    company_name: "",
    placement_year: "",
    location: "",
    package_lpa: "",
    description: "",
    isActive: 1,
  });

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleChange = (e) => {
    setPlacement({
      ...placement,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);

    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setShowCreateModal(true); // Removed as per instruction

    try {
      const formData = new FormData();

      Object.keys(placement).forEach((key) => {
        if (key === "package_lpa") {
        const value = placement[key] === "" ? "0" : placement[key];
        formData.append(key, value);
      } else {
        formData.append(key, placement[key]);
      }
      });

      if (image) {
        formData.append("image", image);
      }

      await axios.post(
        `${process.env.REACT_APP_API_URL}placements/create`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Placement Added Successfully", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
      setTimeout(() => {
        navigate("/placedCandidates");
      }, 2000);

    } catch (error) {
      console.log("Error creating placement:", error);
      toast.error("Failed to create placement", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Add New Placement
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>

              {/* Row 1: Employee ID & Full Name */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="employee_id">
                  <Form.Label>Employee ID</Form.Label>
                  <Form.Control
                    type="text"
                    name="employee_id"
                    value={placement.employee_id}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="full_name">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="full_name"
                    value={placement.full_name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Row>

              {/* Row 2: Designation & Company Name */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="designation">
                  <Form.Label>Designation</Form.Label>
                  <Form.Control
                    type="text"
                    name="designation"
                    value={placement.designation}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="company_name">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="company_name"
                    value={placement.company_name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Row>

              {/* Row 3: Placement Year & Location */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="placement_year">
                  <Form.Label>Placement Year</Form.Label>
                  <Form.Control
                    type="text"
                    name="placement_year"
                    value={placement.placement_year}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="location">
                  <Form.Label>Location</Form.Label>
                  <Form.Control
                    type="text"
                    name="location"
                    value={placement.location}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Row>

              {/* Row 4: Package & Status */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="package_lpa">
                  <Form.Label>Package (LPA)</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="package_lpa"
                    value={placement.package_lpa}
                    onChange={handleChange}
                    placeholder="0.00"
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="isActive">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    name="isActive"
                    value={placement.isActive}
                    onChange={handleChange}
                  >
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Row>

              {/* Description */}
              <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  rows={3}
                  value={placement.description}
                  onChange={handleChange}
                />
              </Form.Group>

              {/* Image Upload */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="imageUpload">
                  <Form.Label>Upload Image</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </Form.Group>
                <Col>
                  {preview && (
                    <div className="image-preview-container">
                      <Form.Label>Preview:</Form.Label>
                      <div>
                        <img
                          src={preview}
                          alt="Preview"
                          loading="lazy"
                          className="image-preview"
                        />
                      </div>
                    </div>
                  )}
                </Col>
              </Row>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-success">
                  Save Placement
                </button>
                <Link to="/placedCandidates" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>

        <ToastContainer />
      </div>
    </>
  );
}
